<template>
  <div class="commentsContainer">
    <div class="header">
      <ul class="tabs">
        <li
          class="typeItem"
          v-for="(item, index) in typeList"
          :key="index"
          :class="{ active: activeName == index }"
          @click="handleTypeClick(index)"
        >
          {{ item }}
        </li>
      </ul>
      <div class="searchContainer">
        <el-input
          placeholder="搜索标题"
          v-model="searchKey"
          clearable
          class="searchKeyInput"
          @keyup.enter.native="handleSearch"
          @clear="handleSearch"
        >
        </el-input>
      </div>
    </div>
    <div class="contentContain">
      <div class="scriptContain">
        <div class="scriptList">
          <div
            class="scriptItem"
            v-for="(item, index) in list"
            :key="index"
            :class="{ scriptActive: scriptIndex == index }"
            @click="getCommentlist(index)"
          >
            <img
              :src="activeName < 4 ? item.n_cover_url[0] : item.cover_url[0]"
              class="thumb"
              v-if="
                (item.n_cover_url && item.n_cover_url.length) ||
                (item.cover_url && item.cover_url.length)
              "
            />
            <div>
              <div class="title">
                {{ item.n_title || item.content }}
              </div>
              <div>
                <span class="infos"
                  >{{ item.display_time }} · 评论 {{ item.comment_num }}</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="noMore" v-if="isAll">已加载全部内容</div>
      </div>
      <div class="commentContain">
        <ul class="commentList">
          <li v-for="(item, index) in commentList" :key="index">
            <!-- <img
              src="../../assets/commentIcon/light.png"
              class="specialIcon"
              v-if="item.tag_id == 1"
            />
            <img
              src="../../assets/commentIcon/god.png"
              class="specialIcon"
              v-if="item.tag_id == 2"
            /> -->
            <img :src="item.u_avatar" class="head" @click="toHome(item)" />
            <div class="textContain">
              <div class="headContainer">
                <p class="userName">{{ item.u_nickname }}</p>
                <div class="authorIcon" v-if="item.u_id == userInfo.u_id">
                  作者
                </div>
              </div>
              <div class="contentContainer">
                <div class="content">
                  {{ item.c_content }}
                </div>
              </div>
              <el-image
                fit="cover"
                :src="item.c_content_img_url"
                :preview-src-list="[item.c_content_img_url]"
                class="commentImg"
                :style="item | commentImgSize(findNearesttargetber)"
                v-if="item.c_content_img_url"
              />
              <div class="actionContainer">
                <div class="timeContain">
                  <p class="isTop" v-if="item.c_is_top > 0">置顶</p>
                  <p class="commentTime">{{ item.display_time }}</p>
                </div>
                <div class="actions">
                  <div class="action" @click="replyToggle(item)">
                    <p class="actionLabel">
                      {{ item.showReply ? "取消回复" : "回复" }}
                    </p>
                    <p class="actionName">
                      {{ item.comment_num > 0 ? item.comment_num : "" }}
                    </p>
                  </div>
                  <div class="action" @click="commentLike(item)">
                    <p class="actionLabel">
                      {{ item.is_like ? "取消点赞" : "点赞" }}
                    </p>
                    <p class="actionName">{{ item.like_num }}</p>
                  </div>
                  <div class="action" @click="commentTop(item)" v-if="topAuth">
                    <p
                      class="actionName"
                      :class="{
                        topText: item.c_is_top > 0,
                        actionLabel: item.c_is_top == 0,
                      }"
                    >
                      {{ item.c_is_top > 0 ? "取消置顶" : "置顶" }}
                    </p>
                  </div>
                  <div class="action" @click="commentDelete(index)">
                    <p class="actionLabel">删除</p>
                  </div>
                </div>
              </div>
              <div class="commentReplyContainer" v-show="item.showReply">
                <el-input
                  type="textarea"
                  :rows="3"
                  placeholder="请输入回复内容"
                  v-model="item.reply"
                  :autosize="true"
                  resize="none"
                >
                </el-input>
                <div class="relpyAddContain">
                  <el-upload
                    drag
                    action="no"
                    accept="image/*"
                    :before-upload="onBeforeUpload"
                    :http-request="(params) => uploadFn(params, item)"
                    class="uploadElemBox"
                  >
                    <img
                      src="../../assets/new/imgIcon.png"
                      class="imgIcon"
                      v-if="item.content_img_url == '' || !item.content_img_url"
                    />
                    <div class="imgUploadedContain" v-else>
                      <img :src="item.content_img_url" class="imgUploaded" />
                      <img
                        src="../../assets/imageDelete.png"
                        class="imageDelete"
                        @click.stop="deleteCommentImg(item)"
                      />
                    </div>
                  </el-upload>
                  <p
                    class="replyBtn"
                    :class="{ hasContent: item.reply != '' }"
                    @click="commentReply(index)"
                  >
                    回复
                  </p>
                </div>
              </div>
              <ul
                class="subCommentsContainer"
                v-if="item.children && item.children.length"
              >
                <li
                  v-for="(subItem, subIndex) in item.children"
                  :key="subIndex"
                >
                  <!-- <img
                  src="../../assets/commentIcon/light.png"
                  class="specialIcon"
                  v-if="subItem.tag_id == 1"
                />
                <img
                  src="../../assets/commentIcon/god.png"
                  class="specialIcon"
                  v-if="subItem.tag_id == 2"
                /> -->
                  <img
                    :src="subItem.u_avatar"
                    class="head"
                    @click="toHome(subItem)"
                  />
                  <div class="textContain">
                    <div class="headContainer">
                      <p class="userName">{{ subItem.u_nickname }}</p>
                      <div
                        class="authorIcon"
                        v-if="subItem.u_id == userInfo.u_id"
                      >
                        作者
                      </div>
                    </div>
                    <div class="contentContainer">
                      <div class="content">
                        回复<span class="toUserName">{{
                          subItem.to_u_nickname
                        }}</span
                        >{{ subItem.c_content }}
                      </div>
                    </div>
                    <el-image
                      fit="cover"
                      :src="subItem.c_content_img_url"
                      :preview-src-list="[subItem.c_content_img_url]"
                      class="commentImg"
                      :style="subItem | commentImgSize(findNearesttargetber)"
                      v-if="subItem.c_content_img_url"
                    />
                    <div class="actionContainer">
                      <div class="timeContain">
                        <p class="isTop" v-if="subItem.c_is_top > 0">置顶</p>
                        <p class="commentTime">{{ subItem.display_time }}</p>
                      </div>
                      <div class="actions">
                        <div class="action" @click="replyToggle(subItem)">
                          <p class="actionLabel">
                            {{ subItem.showReply ? "取消回复" : "回复" }}
                          </p>
                          <p class="actionName">
                            {{
                              subItem.comment_num > 0 ? subItem.comment_num : ""
                            }}
                          </p>
                        </div>
                        <div class="action" @click="commentLike(subItem)">
                          <p class="actionLabel">
                            {{ subItem.is_like ? "取消点赞" : "点赞" }}
                          </p>
                          <p class="actionName">{{ subItem.like_num }}</p>
                        </div>
                        <div
                          class="action"
                          @click="commentDelete(index, subIndex)"
                        >
                          <p class="actionLabel">删除</p>
                        </div>
                      </div>
                    </div>
                    <div
                      class="commentReplyContainer"
                      v-show="subItem.showReply"
                    >
                      <el-input
                        type="textarea"
                        :rows="3"
                        placeholder="请输入回复内容"
                        v-model="subItem.reply"
                        :autosize="true"
                        resize="none"
                      >
                      </el-input>
                      <div class="relpyAddContain">
                        <el-upload
                          drag
                          action="no"
                          accept="image/*"
                          :before-upload="onBeforeUpload"
                          :http-request="(params) => uploadFn(params, subItem)"
                          class="uploadElemBox"
                        >
                          <img
                            src="../../assets/new/imgIcon.png"
                            class="imgIcon"
                            v-if="
                              subItem.content_img_url == '' ||
                              !subItem.content_img_url
                            "
                          />
                          <div class="imgUploadedContain" v-else>
                            <img
                              :src="subItem.content_img_url"
                              class="imgUploaded"
                            />
                            <img
                              src="../../assets/imageDelete.png"
                              class="imageDelete"
                              @click.stop="deleteCommentImg(subItem)"
                            />
                          </div>
                        </el-upload>
                        <p
                          class="replyBtn"
                          :class="{ hasContent: subItem.reply != '' }"
                          @click="commentReply(index, subIndex)"
                        >
                          回复
                        </p>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
              <p
                class="moreComment"
                v-if="
                  item.children &&
                  item.children.length &&
                  item.children.length == item.comment_num > 1 &&
                  item.comment_num > 1
                "
                @click="moreComment(index)"
              >
                点击展开{{ item.comment_num - 1 }}条评论
              </p>
            </div>
          </li>
        </ul>
        <div class="noMore" v-if="commentList.length == 0">暂无评论</div>
      </div>
    </div>
  </div>
</template>

<script>
import { SWNEWS_HOST, NEWS_HOST } from "../../constants/apiHosts";
import { mapState, mapActions } from "vuex";
import { HS_upload } from "./../../utils/huoshanUpload";

export default {
  data() {
    return {
      typeList: ["全部", "图文", "视频", "图集", "帖子"],
      activeName: 0,
      list: [],
      page: 1,
      size: 15,
      isAll: false,
      searchKey: "",
      apis: [
        {
          host: "swnews",
          url: "/api/user/newsList?tab=7&type=0",
        },
        {
          host: "swnews",
          url: "/api/user/newsList?tab=7&type=1",
        },
        {
          host: "swnews",
          url: "/api/user/newsList?tab=7&type=2",
        },
        {
          host: "swnews",
          url: "/api/user/newsList?tab=7&type=3",
        },
        {
          host: "swnews",
          url: "/api/communityMyPost/getMyPostList?tab_type=1",
        },
      ],
      scriptIndex: 0,
      commentPage: 1,
      commentSize: 20,
      commentList: [],
      commentAll: false,
      topAuth: false,
    };
  },
  filters: {
    commentImgSize(item, compute) {
      let rate = 1;
      if (item.c_content_img_width) {
        rate = compute(
          [0.5625, 1, 1.3333],
          item.c_content_img_width / item.c_content_img_height
        );
      }
      switch (rate) {
        case 0.5625:
          // 9:16
          return "width:120px;height:213px;";
        case 1:
          // 1:1
          return "width:160px;height:160px;";
        case 1.3333:
          // 4:3
          return "width:213px;height:160px;";
        default:
          return "width:160px;height:160px;";
      }
    },
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.common.userInfo,
    }),
  },
  created() {
    this.getList();
    this.getUserLevelList();
  },
  mounted() {
    const el = document.getElementsByClassName("scriptContain")[0];
    el.addEventListener("scroll", () => {
      if (
        el.scrollTop + el.clientHeight + 20 >= el.scrollHeight &&
        !this.isAll
      ) {
        this.page++;
        this.getList();
      }
    });
    const el1 = document.getElementsByClassName("commentContain")[0];
    el1.addEventListener("scroll", () => {
      if (
        el.scrollTop + el.clientHeight + 20 >= el.scrollHeight &&
        !this.isAll
      ) {
        this.commentPage++;
        this.getComments();
      }
    });
  },
  methods: {
    handleTypeClick(type) {
      this.activeName = type;
      this.searchKey = "";
      this.scriptIndex = 0;
      this.list = [];
      this.page = 1;
      this.isAll = false;
      this.getList();
    },
    handleSearch() {
      this.scriptIndex = 0;
      this.list = [];
      this.page = 1;
      this.isAll = false;
      this.getList();
    },
    getList() {
      this.isAll = true;

      let url = `https://${this.apis[this.activeName].host}.${
        window.location.href.indexOf("topnews.cn") >= 0
          ? "topnews.cn"
          : "dingnews.net"
      }${this.apis[this.activeName].url}&page=${this.page}&size=${
        this.size
      }&title=${this.searchKey}`;
      this.$axios.get(url).then((res) => {
        if (res.data.code == 0) {
          if (res.data.data.data) {
            res.data.data.returnData = res.data.data.data;
          }
          this.list = this.list.concat(res.data.data.returnData);

          if (res.data.data.returnData.length >= this.size) {
            this.isAll = false;
          }

          if (this.page == 1 && this.list.length > 0) {
            this.getCommentlist(0);
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    getCommentlist(index) {
      this.scriptIndex = index;
      this.commentList = [];
      this.commentPage = 1;
      this.commentAll = false;
      this.getComments();
    },
    getComments() {
      this.commentAll = true;

      this.$axios
        .post(`${SWNEWS_HOST}/api/comment/list`, {
          n_id: this.list[this.scriptIndex].n_id,
          type: 1,
          page: this.commentPage,
          page_size: this.commentSize,
        })
        .then((res) => {
          if (res.data.code == 0) {
            res.data.data.forEach((element) => {
              element.reply = "";
              element.showReply = false;
              element.content_img_url = "";
              element.content_img_height = "";
              element.content_img_width = "";

              if (!element.children) {
                element.children = [];
              }

              if (element.children && element.children.length) {
                element.children.forEach((item) => {
                  item.reply = "";
                  item.showReply = false;
                  element.content_img_url = "";
                  element.content_img_height = "";
                  element.content_img_width = "";
                });
              }
            });
            this.commentList = this.commentList.concat(res.data.data);

            if (res.data.data.length >= this.commentSize) {
              this.commentAll = false;
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    moreComment(index) {
      this.$axios
        .post(`${SWNEWS_HOST}/api/comment/list`, {
          n_id: this.list[this.scriptIndex].n_id,
          type: 2,
          page: 1,
          page_size: 100,
          c_p_id: this.commentList[index].c_id,
        })
        .then((res) => {
          if (res.data.code == 0) {
            res.data.data.forEach((element) => {
              element.reply = "";
              element.showReply = false;
              element.content_img_url = "";
              element.content_img_height = "";
              element.content_img_width = "";
            });
            this.commentList[index].children = res.data.data;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    replyToggle(item) {
      let banData = localStorage.getItem("banData");
      if (banData) {
        banData = JSON.parse(banData);
      }

      if (
        !item.showReply &&
        banData.ban_type == 1 &&
        banData.ban_range_type.indexOf("2") > -1
      ) {
        this.$refs.banShow.getReason(localStorage.getItem("token"));
        this.isBanned = true;
      } else {
        item.showReply = !item.showReply;
      }
    },
    commentReply(index, subIndex) {
      let isOne = true;
      if (subIndex !== undefined) {
        // 二级评论
        isOne = false;
      }

      if (
        (isOne
          ? this.commentList[index].reply
          : this.commentList[index].children[subIndex].reply) == ""
      ) {
        return;
      }

      this.$axios
        .post(`${SWNEWS_HOST}/api/comment/comment`, {
          type: 2,
          content: isOne
            ? this.commentList[index].reply
            : this.commentList[index].children[subIndex].reply,
          n_id: this.list[this.scriptIndex].n_id,
          n_type: this.list[this.scriptIndex].n_type || 6,
          n_title:
            this.list[this.scriptIndex].n_title ||
            this.list[this.scriptIndex].content,
          n_cover_url:
            JSON.stringify(this.list[this.scriptIndex].n_cover_url) ||
            JSON.stringify(this.list[this.scriptIndex].cover_url),
          c_id: isOne
            ? this.commentList[index].c_id
            : this.commentList[index].children[subIndex].c_id,
          to_u_id: isOne
            ? this.commentList[index].u_id
            : this.commentList[index].children[subIndex].u_id,
          content_img_url: isOne
            ? this.commentList[index].content_img_url
            : this.commentList[index].children[subIndex].content_img_url,
          content_img_height: isOne
            ? this.commentList[index].content_img_height
            : this.commentList[index].children[subIndex].content_img_height,
          content_img_width: isOne
            ? this.commentList[index].content_img_width
            : this.commentList[index].children[subIndex].content_img_width,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.$message({
              message: "评论成功",
              type: "success",
            });

            if (isOne) {
              this.commentList[index].showReply = false;
              this.commentList[index].reply = "";
            } else {
              this.commentList[index].children[subIndex].showReply = false;
              this.commentList[index].children[subIndex].reply = "";
            }

            this.moreComment(index);
            this.getList();
            this.commentList[index].comment_num++;
            this.list[this.scriptIndex].comment_num++;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    commentLike(item) {
      this.$axios
        .post(`${NEWS_HOST}/api/fav/favour`, {
          type: 2,
          n_id: this.list[this.scriptIndex].n_id,
          n_type: this.list[this.scriptIndex].n_type || 6,
          n_title:
            this.list[this.scriptIndex].n_title ||
            this.list[this.scriptIndex].content,
          n_cover_url:
            JSON.stringify(this.list[this.scriptIndex].n_cover_url) ||
            JSON.stringify(this.list[this.scriptIndex].cover_url),
          c_id: item.c_id,
          c_content: item.c_content,
          to_u_id: item.u_id,
          action: item.is_like > 0 ? 1 : 0,
        })
        .then((res) => {
          if (res.data.code == 0) {
            if (item.is_like) {
              item.is_like = 0;
              item.like_num--;
            } else {
              item.is_like = 1;
              item.like_num++;
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    commentTop(item) {
      this.$axios
        .post(`${NEWS_HOST}/api/comment/operateTop`, {
          c_id: item.c_id,
          is_top: item.c_is_top > 0 ? 2 : 1,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.commentList = [];
            this.commentPage = 1;
            this.commentAll = false;

            setTimeout(() => {
              this.getComments();
            }, 800);
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    commentDelete(index, subIndex) {
      let isOne = true;
      if (subIndex !== undefined) {
        // 二级评论
        isOne = false;
      }

      this.$confirm("确定要删除该条评论吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(`${NEWS_HOST}/api/comment/del`, {
              c_id: isOne
                ? this.commentList[index].c_id
                : this.commentList[index].children[subIndex].c_id,
            })
            .then((res) => {
              if (res.data.code == 0) {
                this.$message({
                  message: "删除成功",
                  type: "success",
                });

                if (isOne) {
                  // 一级评论删除
                  this.commentList.splice(index, 1);
                } else {
                  // 二级评论删除
                  this.moreComment(index);
                }

                //this.getList();
                this.commentList[index].comment_num--;
                this.list[this.scriptIndex].comment_num--;
              } else {
                this.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {});
    },
    getUserLevelList() {
      this.$axios
        .get(`${SWNEWS_HOST}/api/creatorScore/getUserLevelList`, {})
        .then((res) => {
          if (res.data.code == 0) {
            res.data.data.user_privilege_list.forEach((item) => {
              if (item.privilege_name == "评论置顶" && item.is_open == 1) {
                this.topAuth = true;
              }
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    toHome(item) {
      window.open(`https://www.topnews.cn/home/${item.u_id}`);
    },
    onBeforeUpload(file) {
      const isIMAGE = file.type.indexOf("image/") >= 0;
      //const isLt1M = file.size / 1024 / 1024 < 1;

      if (!isIMAGE) {
        this.$message.error("上传文件只能是图片格式！");
        return false;
      } else {
        return true;
      }
      // if (!isLt1M) {
      //   this.$message.error("上传文件大小不能超过 1MB!");
      // } && isLt1M
    },
    uploadFn(val, item) {
      HS_upload(
        val.file,
        (data) => {
          this.$set(item, "content_img_url", data.url);
          this.getFileImageSize(val.file).then((size) => {
            item.content_img_height = size.height;
            item.content_img_width = size.width;
          });
        },
        (error) => {
          console.log("error:" + error);
        },
        (processPercent) => {
          console.log("processPercent:" + processPercent);
        }
      );
    },
    deleteCommentImg(item) {
      item.content_img_url = "";
      item.content_img_height = "";
      item.content_img_width = "";
    },
    getFileImageSize(file) {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;
          img.onload = () => {
            resolve({ width: img.width, height: img.height });
          };
        };
        reader.readAsDataURL(file);
      });
    },
    findNearesttargetber(arr, target) {
      let mid;
      let l = 0;
      let r = arr.length - 1;
      // 保证指针最终停留在相邻的两个数,所以这里是判断是否大于1
      while (r - l > 1) {
        mid = Math.floor((l + r) / 2);
        // 如果目标数比中间小，所以范围在左边
        if (target < arr[mid]) {
          r = mid;
        } else {
          l = mid;
        }
      }
      return Math.abs(target - arr[l]) <= Math.abs(target - arr[r])
        ? arr[l]
        : arr[r];
    },
  },
};
</script>

<style lang="scss" scoped>
.commentsContainer {
  background-color: #fff;
  padding-right: 14px;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #eeeeee;

    .tabs {
      display: flex;

      .typeItem {
        width: 36px;
        text-align: center;
        color: #333333;
        font-family: "PingFang SC";
        font-size: 18px;
        font-weight: 500;
        line-height: 25px;
        cursor: pointer;
        margin: 0 28px 0 28px;
        line-height: 68px;
      }

      .active {
        border-bottom: 3px solid #f32432;
      }
    }

    .searchContainer {
      margin-right: 10px;

      .searchKeyInput {
        margin: 0;
        font-size: 14px;
      }
    }
  }

  .contentContain {
    display: flex;

    .scriptContain {
      width: 458px;
      height: calc(100vh - 172px);
      overflow-y: scroll;
      flex-shrink: 0;

      .scriptList {
        padding: 3px 24px;
        border-right: 1px solid #eeeeee;

        .scriptItem {
          padding: 20px;
          display: flex;
          align-items: center;
          cursor: pointer;
          border-bottom: 1px solid #eeeeee;

          &:last-child {
            border-bottom: 0;
          }

          .thumb {
            width: 160px;
            height: 90px;
            border-radius: 8px;
            object-fit: cover;
            margin-right: 20px;
            flex-shrink: 0;
          }

          .title {
            color: #333333;
            font-family: "PingFang SC";
            font-size: 16px;
            font-weight: 500;
            line-height: 21px;
            margin-bottom: 10px;
            height: 42px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            word-break: break-all;
          }

          .infos {
            color: #999999;
            font-family: "PingFang SC";
            font-size: 12px;
            font-weight: 400;
            line-height: 17px;
          }
        }

        .scriptActive {
          background: #f8f8f8;
        }
      }
    }

    .commentContain {
      flex: 1;
      height: calc(100vh - 172px);
      overflow-y: auto;
      min-width: 550px;

      .commentList {
        padding: 3px 10px 3px 20px;

        li {
          padding: 20px 0;
          border-top: 1px solid #eeeeee;
          position: relative;
          display: flex;

          .specialIcon {
            height: 96px;
            position: absolute;
            right: 0;
            top: 10px;
          }

          .head {
            width: 38px;
            height: 38px;
            border-radius: 50%;
            object-fit: cover;
            margin-right: 16px;
            cursor: pointer;
          }

          .textContain {
            flex: 1;
          }

          .headContainer {
            display: flex;
            align-items: center;

            .userName {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
              line-height: 20px;
            }

            .authorIcon {
              border-radius: 2px;
              background: #e6f0ff;
              color: #5574e7;
              font-family: "PingFang SC";
              font-size: 12px;
              font-weight: 400;
              line-height: 20px;
              margin-left: 8px;
              padding: 0 8px;
            }
          }

          .contentContainer {
            position: relative;
            margin-top: 8px;

            .content {
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
              line-height: 22px;
            }
          }

          .commentImg {
            margin-top: 8px;
            display: block;
          }

          .actionContainer {
            margin-top: 16px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .timeContain {
              display: flex;
              align-items: center;

              .commentTime {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #bbbbbb;
                line-height: 20px;
              }

              .isTop {
                color: #f32432;
                font-family: "PingFang SC";
                font-size: 14px;
                font-weight: 400;
                line-height: 20px;
                margin-right: 8px;
              }
            }

            .actions {
              display: flex;

              .action {
                display: flex;
                align-items: center;
                margin-right: 32px;
                cursor: pointer;

                .actionName {
                  font-size: 14px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #666666;
                  line-height: 20px;
                  margin-left: 4px;
                }

                .actionLabel {
                  color: #999999;
                  font-family: "PingFang SC";
                  font-size: 14px;
                  font-weight: 400;
                  line-height: 20px;
                }

                .topText {
                  color: #ffc14e;
                }
              }

              .action:last-child {
                margin-right: 10px;
              }
            }
          }

          .subCommentsContainer {
            .toUserName {
              color: rgb(153, 153, 153);
              padding: 0 10px;
            }

            li {
              position: relative;

              .specialIcon {
                height: 96px;
                position: absolute;
                right: 0;
                top: 10px;
              }
            }

            li:last-child {
              padding-bottom: 0;
            }
          }

          .moreComment {
            color: rgb(83, 113, 243);
            font-size: 16px;
            margin: 20px 0 0 40px;
            display: inline-block;
            cursor: pointer;
          }

          .commentReplyContainer {
            width: calc(100% - 10px);
            min-height: 140px;
            border-radius: 4px;
            background: #f6f7f9;
            margin-top: 16px;
            padding-bottom: 12px;

            /deep/.el-textarea {
              padding: 12px;
              background: #f6f7f9;
              border: 0;
              min-height: 80px;
              margin-bottom: 12px;

              textarea {
                background: #f6f7f9;
                border: 0;
                padding: 0;
              }
            }

            .relpyAddContain {
              display: flex;
              justify-content: space-between;
              padding-left: 12px;
              align-items: flex-end;

              /deep/.el-upload-dragger {
                width: fit-content;
                height: fit-content;
                border: 0;
                padding: 0;
                background-color: inherit;

                .imgIcon {
                  height: 24px;
                }

                .imgUploadedContain {
                  position: relative;

                  .imgUploaded {
                    width: 50px;
                    height: 50px;
                    border-radius: 4px;
                  }

                  .imageDelete {
                    position: absolute;
                    top: 0;
                    right: 0;
                    width: 15px;
                  }
                }
              }

              /deep/.el-upload-list {
                display: none;
              }
            }

            .replyBtn {
              width: 68px;
              height: 36px;
              line-height: 36px;
              background: rgba(234, 14, 14, 0.5);
              border-radius: 6px;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #ffffff;
              text-align: center;
              float: right;
              margin-right: 12px;
            }

            .hasContent {
              background: #ea0e0e;
              cursor: pointer;
            }
          }
        }

        li:first-child {
          border-top: 0;
        }
      }
    }

    .noMore {
      color: #999999;
      text-align: center;
      font-family: "PingFang SC";
      font-size: 12px;
      font-weight: 400;
      line-height: 297px;
    }
  }
}
</style>
